const closeStakingBanner = function ({ commit }) {
  commit('SET_REOPEN_STAKING_BANNER_ON');
};

export default {
  closeStakingBanner
};
